export var TooltipStyle;

(function (TooltipStyle) {
  TooltipStyle["Default"] = "default";
  TooltipStyle["Green"] = "green";
})(TooltipStyle || (TooltipStyle = {}));